import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./pricesLanding.scss";
import LandingHeader from "./LandingHeader";
import LandingFooter from "./LandingFooter";

const PricesLanding = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id="pricesLanding" className="pricesLandingContainer">
      <div className="container py-5">
        {/* Navigation */}
        <LandingHeader />

        <div className="row g-3 extra-large-space"></div>

        {/* Main Heading */}
        <div className="text-center mb-3">
          <h1 className="fw-bold text-black display-5">
            You are lucky because beta testing of app.speqqle is currently free.
          </h1>
        </div>

        <div className="row g-3 extra-large-space"></div>

        {/* Call-to-Action Button */}
        <div className="text-center mb-5">
          <button
            className="btn btn-lg fw-bold text-white"
            style={{
              backgroundColor: "rgb(228, 108, 10)",
              borderRadius: "10px",
            }}
          >
            Try it out now!
          </button>
        </div>
      </div>

      <div className="row g-3 extra-large-space"></div>
      <div className="row g-3 extra-large-space"></div>

      {/* Footer */}
      <LandingFooter />
    </div>
  );
};

export default PricesLanding;
